// 2024 - Holiday not yet announced, still set to same date as 2023
export const isHolidaySeason = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const isHolidayStart = new Date(`${currentYear}-11-02T00:00:00`);
  const isHolidayEnd = new Date(`${currentYear}-12-31T23:59:59`);

  return today >= isHolidayStart && today <= isHolidayEnd;
};
